






















































































import {
  defineComponent, reactive, toRefs, watch, computed, ComputedRef,
} from '@vue/composition-api'

const initialState: {
  showMe: boolean;
  hasFooterData: unknown;
} = {
  showMe: true,
  hasFooterData: [],
}

export default defineComponent({
  name: 'ModalDialog',

  props: {
    kind: {
      type: String,
      default: 'primary',
      validator: (val: string) => [
        'primary',
        'secondary',
        'accent',
        'error',
        'info',
        'success',
        'warning',
      ].includes(val),
    },

    // Use this prop to show / hide the dialog
    // from the parent
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    cancelBtnText: {
      type: String,
      default: 'Annuller',
    },
    confirmBtnText: {
      type: String,
      default: 'Ok',
    },
    // Use this prop to dynamically enable/disable the confirm button.
    // Useful if e.g. you have some precondition (e.g. a checkbox that
    // must be checked) before confirmation is allowed. The checkbox
    // or other form elements could live in the default slot and
    // be controlled by the parent.
    disableConfirm: {
      type: Boolean,
      default: false,
    },
    // Disable all buttons
    disableButtons: {
      type: Boolean,
      default: false,
    },
    // Same as vuetify's dialog persistent prop:
    // wont close the modal if clicked outside
    persistent: {
      type: Boolean,
      default: false,
    },
    // Use this to dynamically hide/show footer slot
    showFooter: {
      type: Boolean,
      default: true,
    },
    // Use this to dynamically hide/show 'processing' slot
    // this will also disable buttons
    processing: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {
    const state = reactive({ ...initialState })

    function confirm(): void {
      context.emit('confirmed')
    }
    function cancel(): void {
      context.emit('cancelled')
    }

    // Check if any content is passed to the default slot
    const hasSlotData: ComputedRef = computed(() => context.slots.default)

    const icon: ComputedRef = computed(() => {
      if (props.kind === 'error') return context.root.$vuetify.icons.values.error
      return ''
    })

    watch(
      () => props.show,
      (show) => {
        state.showMe = show
      },
    )

    watch(
      () => state.showMe,
      (show) => {
        if (!show) context.emit('cancelled')
      },
    )

    return {
      ...toRefs(state),
      confirm,
      cancel,
      hasSlotData,
      icon,
    }
  },

})

